import React from 'react';

import Step from 'components/stepper/Step';

import EditRecipeBodyLoading from './EditRecipeBodyLoading';

const EditRecipeBodyLoadingStep = ({ Read, pageTitle, exitPage }) => {
  const { notFound, isLoading, loadRecipe, hasFailed } = Read;

  return (
    <Step
      stepTitle={pageTitle}
      onBackButtonClick={exitPage}
      spacing={8}
      renderBody={() => (
        <EditRecipeBodyLoading
          notFound={notFound}
          isLoading={isLoading}
          loadRecipe={loadRecipe}
          hasFailed={hasFailed}
        ></EditRecipeBodyLoading>
      )}
    ></Step>
  );
};

export default EditRecipeBodyLoadingStep;
